import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {Creature} from "@/store/level/types";
import TextUtils from "@/utils/text-utils";
import {ArtifactInfo} from "@/store/artifact/types";
import ArtifactUtils from "@/utils/artifact-utils";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {CreatureUtils} from "@/utils/creature-utils";
import {Sizes} from "@/constants/size";
import {PickArtifactCreaturesNavPanel} from "@/scenes.ui/pick-artifact-creatures-nav-panel";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";

export enum Mode { TAKING, REPLACING }

export class ArtifactPickPanel extends VerticalStandardPanel {

    private exitCallback: (() => unknown) | undefined;
    private creatureCallback: ((id: number) => unknown) | undefined = undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, mode: Mode, ai: ArtifactInfo,
                exitCallback: () => unknown, creatureCallback: (creatureId: number) => unknown, onTakingWithNoSlotsCallback?: (openUnlockPanel: boolean) => unknown,
                onReplacingWithNoSlotsCallback?: () => unknown) {
        super(scene, canvas, ArtifactPickPanel.getTitle(mode));

        const self = this;
        this.creatureCallback = creatureCallback;
        this.exitCallback = exitCallback;

        let nameText = TextUtils.addTextByFamily(scene, ai.name.toUpperCase(), 0, -180,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0, -110, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.8);
        let artIcon = SpriteUtils.addSprite(this.scene, 0, -110, ai.atlasKey, ai.imageKey);

        let artEffectText = TextUtils.addTextByFamily(scene, ArtifactUtils.getEffectText(ai. effectType, ai.effectValue).toUpperCase(), 0, -64,
            '#e0e0e0', 13, 'normal', 450, Fonts.ARIAL_MT);

        if (PlayerStore.getPlayer()!.stair > 10) {
            let artLevText = TextUtils.addTextByFamily(scene, Tr('maks.ur') + ai.levelsCount + ', ' + Tr('max') + ' ' + ArtifactUtils.getEffectText(ai.effectType, ai.maxEffectValue).toUpperCase(),
                0, -38, '#a79d9d', 10, 'normal', 450, Fonts.ARIAL_MT);
            this.add(artLevText);
        }

        let choseCreatureText = TextUtils.addTextByFamily(scene, ArtifactPickPanel.getMainText(ai, mode),
            0, 10, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);

        this.add([nameText, light, artIcon, artEffectText, choseCreatureText]);
        if (ai.possibleCreatureIds && ai.possibleCreatureIds.length > 0) {
            let creatures: Creature[] = [];
            for (let creatureId of ai.possibleCreatureIds) {
                creatures.push(CreatureUtils.getCreatureById(creatureId));
            }

            let creaturesNavPanel = new PickArtifactCreaturesNavPanel(scene, canvas, 0, 130, creatures, (creatureId: number) => {
                self.creatureCallback!(creatureId);
                self.close();
            });

            this.add(creaturesNavPanel);

        } else if (CreatureUtils.findFirstCreatureAbleToGetArtifact(PlayerStore.getPlayer()!, Sizes.MAX_ARTIFACT_SLOTS_COUNT)) {

            let unlockOfferText = TextUtils.addTextByFamily(scene, Tr('razblokirovat') + '?',
                0, 40, '#fff4da', 13, 'normal', 350, Fonts.ARIAL_MT);

            let unlockButton = new SquareButton(this.scene, 100, 135, 0, Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_UI, Keys.UI_LOCK, Tr('razblokirovat'), false);

            if (onTakingWithNoSlotsCallback != null) { unlockButton.setCallback(() => onTakingWithNoSlotsCallback(true)); }
            if (onReplacingWithNoSlotsCallback != null) { unlockButton.setCallback(() => onReplacingWithNoSlotsCallback()); }

            let acceptButton = new SquareButton(this.scene, -100, 135, 0, Keys.UI_ART_BROWN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('zakrit'), false);

            acceptButton.setCallback(() => {
                if (self.isOnTop()) {
                    self.onClose();
                    self.close();
                }
            });

            this.add([unlockOfferText, unlockButton, acceptButton]);
        } else {
            this.addCloseButton(Tr('horosho'));
        }
    }

    private static getMainText(ai: ArtifactInfo, mode: Mode): string {
        if (ai.possibleCreatureIds && ai.possibleCreatureIds.length > 0) {
            return this.getChooseText(mode);
        } else {
            return this.getNoSlotsText(mode);
        }
    }

    protected onClose(): void {
        this.exitCallback!();
    }

    public setCallback(creatureCallback: () => unknown): void {
        this.creatureCallback = creatureCallback;
    }

    private static getTitle(mode: Mode) {
        switch (mode) {
            case Mode.TAKING:
                return Tr('novaja.nahodka');
            case Mode.REPLACING:
                return Tr('peremeschenie');
        }
        return '';
    }

    private static getChooseText(mode: Mode) {
        switch (mode) {
            case Mode.TAKING:
                return Tr('viberi.kto.iz.geroev.poluchit.predmet');
            case Mode.REPLACING:
                return Tr('viberi.komu.peredat.predmet');
        }
        return '';
    }

    private static getNoSlotsText(mode: Mode) {
        switch (mode) {
            case Mode.TAKING:
                return Tr('net.svobodnogo.mesta.dlja.artefakta');
            case Mode.REPLACING:
                return Tr('uvi.sloti.vseh.ostalnih.geroev.zanjati');
        }
        return '';
    }
}
